export default function ContactForm() {
    window.addEventListener('unload', function (event) {
        document.addEventListener('wpcf7mailsent', function (event) {
            $('.wpcf7-form')[0].reset();
        }, false);

    });
    document.addEventListener('wpcf7mailsent', function (event) {
        $('.wpcf7-form .wpcf7-form-control').val('');
    }, false);
}
